import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FilterStaticBase } from '@portal/shared/ui/filter/src/lib/components/static-base';
import { FILTER_CONTENT_ITEM, ISelectInput, SearchSelector } from '@portal/shared/ui/filter';
import { ProcessorTypes } from '@portal/entity-services/payment-contracts/src/lib/components/form/processor-type.list';
import { TransactionFilterList } from '../transaction-filters.list';
import { FiltersService } from '@portal/shared/ui/filter/src/lib/services/filters.service';
import { SupportedProcessorSettingsService } from '@apps/portal/src/app/services/supported-processor-settings.service';
import { TransactionFilter } from '../../../enums/transaction-filter.enum';
import cloneDeep from 'lodash/cloneDeep';
@Component({
  selector: 'portal-filter-processor',
  templateUrl: './processor.component.html',
  providers: [
    {
      provide: FILTER_CONTENT_ITEM,
      useExisting: ProcessorComponent,
    },
  ],
  standalone: false,
})
export class ProcessorComponent extends FilterStaticBase {
  @Input()
  isMainDropdownFilter: boolean;
  @Input()
  showFilterSubMenu: boolean;
  @Output()
  processorTextName: EventEmitter<string> = new EventEmitter();
  processorText = this.transactionfilters.list.find(
    (filter) => filter.id === TransactionFilter.Processor,
  ).text;
  processors: ISelectInput[];

  constructor(
    private processorTypes: ProcessorTypes,
    private transactionfilters: TransactionFilterList,
    private filtersService: FiltersService,
    private supportedProcessorSettingService: SupportedProcessorSettingsService,
  ) {
    // Get processor configuration (selector and list)
    const config = processorTypes.getProcessorConfiguration();
    const selector = config.selector === 'destinationProcessor' ? SearchSelector.DestinationProcessor : SearchSelector.SourcePim;
    super(selector, config.processors);
    this.processors = cloneDeep(config.processors);

    this.filtersService.actionRemoveFilter$.subscribe((entityToRemove: ISelectInput) => {
      if (this.searchSelector === entityToRemove.key) {
        const selectedEntity = this.localPreSelectedEntities.get(entityToRemove.id);
        if (selectedEntity?.id) {
          this.onEntityRemoved(entityToRemove);
          this.onFilterApplied();
          this.itemToggled.emit();
        }
      }
    });

    this.supportedProcessorSettingService.isProcessorFetched$.subscribe(() => {
      // Re-fetch configuration when processor settings change
      const config = this.processorTypes.getProcessorConfiguration();
      this.searchSelector = config.selector === 'destinationProcessor' ? SearchSelector.DestinationProcessor : SearchSelector.SourcePim;
      this.setAllEntities(config.processors);
      this.processors = cloneDeep(config.processors);
    });

    this.subMenuComponentSelected$.subscribe((submenu) => {
      if (this.searchSelector.includes(submenu)) {
        this.synchronizeLocalPreSelectedEntities();
      }
      this.updateEntities();
    });

    this.updateEntities$.subscribe(() => {
      if (this.isMainDropdownFilter) {
        this.synchronizeLocalPreSelectedEntities();
      }
      this.updateEntities();
    });

    this.updateCounter$.subscribe(() => {
      const localPreSelected: Map<string, ISelectInput> = new Map();
      if (this.criteriaMapPreSelected.has(this.searchSelector)) {
        const argumentArr = this.getArgumentArray(
          this.criteriaMapPreSelected,
          this.searchSelector,
        );

        if (this.criteriaMapPreSelected.get(this.searchSelector)?.argument) {
          argumentArr?.forEach((argument) => {
            localPreSelected.set(argument, {
              id: argument,
              text: this.processorTypes.getValue(argument),
            });
          });
          this.localPreSelectedEntities = cloneDeep(localPreSelected);
        } else {
          this.localPreSelectedEntities.clear();
        }
      }
      this.updateEntities();
    });
  }

  onFilterAppliedAndEntitiesUpdated(): void {
    const config = this.processorTypes.getProcessorConfiguration();
    this.entities = config.processors;
    this.onFilterApplied();
    this.updateEntities();
    if (this.isOpen) {
      this.closeSubmenus$.next(true);
    }
    this.processorTextName.emit(this.processorText);
    this.isOpen = false;
  }

  private synchronizeLocalPreSelectedEntities(): void {
    if (this.criteriaMapPreSelected?.get(this.searchSelector)?.argument) {
      const argumentArr = this.getArgumentArray(this.selectedEntities, this.searchSelector);
      this.localPreSelectedEntities.clear();
      argumentArr?.forEach((argument) => {
        this.setLocalPreSelectedEntities(argument, this.processorTypes.getValue(argument));
      });
    } else {
      this.localPreSelectedEntities.clear();
    }
    this.updateEntities();
  }
}
